export default function DropdownSelect() {
            const KEY_CODE_SPACE = 32;
            const KEY_CODE_ENTER = 13;
            const KEY_CODE_ESC = 27;
            const KEY_CODE_UP = 38;
            const KEY_CODE_DOWN = 40;

            return {
                restrict: 'AE',
                link: function(scope, element) {
                    const elem = angular.element(element);
                    let counter = 0;
                    let item;

                    elem.keydown(function(event) {

                        /**
                         * Prevent default scrolling on space and up/down arrows
                         */
                        if ([KEY_CODE_SPACE, KEY_CODE_UP, KEY_CODE_DOWN].indexOf(event.keyCode) !== -1) {
                            event.preventDefault();
                        }
                    });

                    elem.keyup((event) => { // eslint-disable-line
                        if (event.keyCode === KEY_CODE_SPACE) {
                            elem.addClass('active');
                            if (!item) {
                                item = elem.find('ul li').get(0);
                                angular.element(item).addClass('active');
                            }
                        }
                        if (event.keyCode === KEY_CODE_ESC) {
                            elem.removeClass('active');
                        }

                        if (elem.hasClass('active')) {
                            if (event.keyCode === KEY_CODE_UP) {
                                if (counter === 0) {
                                    counter = elem.find('ul li').length - 1;
                                } else {
                                    counter--;
                                }

                                elem.find('ul li').removeClass('active');
                                item = elem.find('ul li').get(counter);
                                angular.element(item).addClass('active');
                            } else if (event.keyCode === KEY_CODE_DOWN) {
                                if (counter === elem.find('ul li').length - 1) {
                                    counter = 0;
                                } else {
                                    counter++;
                                }

                                elem.find('ul li').removeClass('active');
                                item = elem.find('ul li').get(counter);
                                angular.element(item).addClass('active');
                            } else if (event.keyCode === KEY_CODE_ENTER) {
                                angular.element(item).find('a').trigger('click');
                            }
                        }
                    });
                },
            };
}



// WEBPACK FOOTER //
// ./src/app/directives/dropdownSelect.directive.js